import * as React from "react";

export const OffSvg = () => <svg width="40px" height="40px" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.06" cx="30.5" cy="30.5" r="30.5" fill="#804C80"/>
<path d="M31.0008 28.8C32.2108 28.8 33.2008 27.81 33.2008 26.6V22.2C33.2008 20.99 32.2108 20 31.0008 20C29.7908 20 28.8008 20.99 28.8008 22.2V26.6C28.8008 27.81 29.7908 28.8 31.0008 28.8Z" fill="#804C80"/>
<path d="M38.81 23.19C38.48 22.86 38.15 22.75 37.6 22.75C36.72 22.75 35.95 23.52 35.95 24.4C35.95 24.84 36.17 25.28 36.39 25.61C37.82 27.04 38.59 28.91 38.59 31C38.59 35.29 35.18 38.7 30.89 38.7C26.6 38.7 23.19 35.29 23.19 31C23.19 28.91 24.07 26.93 25.5 25.61C25.83 25.28 26.05 24.84 26.05 24.4C26.05 23.52 25.28 22.75 24.4 22.75C23.96 22.75 23.52 22.97 23.19 23.19C21.21 25.17 20 27.92 20 31C20 37.05 24.95 42 31 42C37.05 42 42 37.05 42 31C42 27.92 40.79 25.17 38.81 23.19Z" fill="#804C80"/>
</svg>;



// WEBPACK FOOTER //
// ./src/images/OffSvg.tsx